import { forwardRef, type Ref, type SVGProps } from "react";
const IconTikTokSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M27.988 9.01a6.77 6.77 0 0 1-4.16-1.424 7.1 7.1 0 0 1-2.616-4.263A7.3 7.3 0 0 1 21.079 2h-4.46v12.492l-.006 6.843c0 1.83-1.162 3.38-2.773 3.926a3.96 3.96 0 0 1-3.345-.377 4.16 4.16 0 0 1-1.973-3.487c-.034-2.313 1.79-4.199 4.045-4.199.445 0 .873.075 1.273.21v-4.641a8.6 8.6 0 0 0-1.286-.098c-2.468 0-4.777 1.052-6.427 2.947a8.7 8.7 0 0 0-2.11 5.173c-.152 2.516.746 4.908 2.489 6.673A8.42 8.42 0 0 0 12.555 30a8.45 8.45 0 0 0 6.048-2.538 8.66 8.66 0 0 0 2.505-6.092l-.024-10.218a11.2 11.2 0 0 0 2.506 1.498 11 11 0 0 0 4.41.911V9.01z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconTikTokSVG);
ForwardRef.displayName = "IconTikTok";
export { ForwardRef as IconTikTok };
